import script from "./Result.vue?vue&type=script&setup=true&lang=js"
export * from "./Result.vue?vue&type=script&setup=true&lang=js"

import "./Result.vue?vue&type=style&index=0&id=06b4ff69&lang=css"

const __exports__ = script;

export default __exports__